import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const existing = localStorage.getItem("userEmail");
    if (existing) {
      const verified = localStorage.getItem("userVerified") === "true";
      navigate(verified ? "/dashboard" : "/verify-otp");
    }
  }, [navigate]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error("Please enter a valid email address");
      return;
    }
    if (!formData.password) {
      toast.error("Password is required");
      return;
    }
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, formData);
      const { is_verified, role } = response.data;
      localStorage.setItem("userEmail", response.data.email);
      localStorage.setItem("userRole", role || "student");
      localStorage.setItem("userVerified", is_verified ? "true" : "false");

      if (role === "admin") {
        toast.success("Logged in as admin");
        navigate("/dashboard");
        return;
      }

      if (is_verified) {
        toast.success("Login successful!");
        navigate("/dashboard");
      } else {
        toast.success("Please verify your email with OTP");
        navigate("/verify-otp");
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container auth-page-container">
      <div className="auth-card" data-testid="login-card">
        <h1>Welcome Back</h1>
        <p>Sign in to continue your CarNav assessment</p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              className="form-input"
              value={formData.email}
              onChange={handleChange}
              required
              data-testid="email-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              className="form-input"
              value={formData.password}
              onChange={handleChange}
              required
              data-testid="password-input"
            />
          </div>

          <button
            type="submit"
            className="btn-primary"
            disabled={loading}
            data-testid="login-button"
          >
            {loading ? "Signing In..." : "Sign In"}
          </button>
        </form>

        <div className="link-text">
          Don't have an account? <Link to="/register" data-testid="register-link">Register</Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
